import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import DigitalSignature from "../digital_signature/DigitalSignature";

function ModalSignature(props) {
  const [show, setShow] = useState(false);
  const [showDowloadDocument, setShowDowloadDocument] = useState(false);
  const [signInStep, setSignInStep] = useState(false);
  const [finalDocumentUrlPDF, setFinalDocumentUrlPDF] = useState(
    props.el.extra_attributes.document_information.signature
      ? props.el.extra_attributes.document_information.signature
      : ""
  );

  useEffect(() => {
    if (signInStep) {
      props.setNextButtonDisable(false);
    }
  }, [signInStep]);

  useEffect(() => {
    if (props.el.extra_attributes.signature) {
      if (props.el.extra_attributes.current_stage_signed) {
        props.setNextButtonDisable(false);
      } else {
        props.setNextButtonDisable(true);
      }
    } else {
      props.setNextButtonDisable(false);
    }
  }, [showDowloadDocument]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow} disabled={props.mode === 2 ? true : false}>
        Firmar Documento
      </Button>
      <a href={finalDocumentUrlPDF} className="dowload-document">
        <Button
          variant="success"
          style={
            showDowloadDocument ||
            props.el.extra_attributes.document_information.signature
              ? { display: "inline", marginLeft: "1em" }
              : { display: "none", marginLeft: "1em" }
          }
        >
          Descargar Documento
        </Button>
      </a>

      <Modal show={show} onHide={handleClose} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DigitalSignature
            el={props.el}
            onChangeHandler={props.onChangeHandler}
            hasErrors={props.el.error}
            errorDigital={props.errorDigital}
            state={props.state}
            setState={props.setState}
            mode={props.mode}
            stage={props.stage}
            isDocument={true}
            htmlIntoBase64={props.htmlIntoBase64}
            showModalSignature={setShow}
            showDowloadDocument={setShowDowloadDocument}
            finalDocumentUrlPDF={finalDocumentUrlPDF}
            setFinalDocumentUrlPDF={setFinalDocumentUrlPDF}
            setNextButtonDisable={props.setNextButtonDisable}
            setSignInStep={setSignInStep}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalSignature;
